<template>
	<div class="border-b border-gray-300" id="nav">
		<div class="justify-between flex items-center max-w-6xl mx-auto px-16 py-2 w-full">
			<router-link to="/">
				<img class="h-12" src="../assets/logo.png">
			</router-link>
			<div class="flex p-2">
				<div class="px-4">
					<router-link tag="a" to="/">Home</router-link>
				</div>
				<div class="px-4">
					<router-link tag="a" to="/services">Our Services</router-link>
				</div>
				<div class="px-4">
					<router-link tag="a" to="/contact">Contact Us</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Nav',
}

</script>